<template>
	<div class="editEmployer">
		<!-- Main Body Content area -->
        <div class="o-main-content-area">
            <!-- Heading Section -->
            <div class="row c-responsive-fixwidth">
                <div class="col-md-6">
                    <h1 class="h1">Edit Employer: {{addEmployer.employerName}}</h1>
                </div>
                <div class="col-md-6 text-right">
                    <ul class="o-filter-area">
                        <li><a href="javascript: void(0)" @click="backToEmployerList()" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a></li>
                        <li><a href="javascript: void(0)" @click="uploadProfileImg()" class="c-common-btn c-common-btn--large c-common-btn--green"><i class="fa fa-save"></i> Save</a></li>
                    </ul>
                </div>
            </div>
            <!-- /Heading Section -->
        </div>
        <div class="o-ndividualArea c-responsive-fixwidth">
            <div class="o-ndividualTable employer-info">
               
                <div class="field-group">
                    <div class="row">
                        <div class="col-sm-3">
                            <div class="c-common-space c-common-box-shadow c-radius3">
                                <div class="c-user-tab-content clearfix o-skillset-area o-employer-file-upload-height">
                                    <div class="layout-table">
                                        <div class="layout-table-cell">
                                            <div class="form-group employerpic-upload-sec">
                                                <div class="employerpic-upload"> 
<!--                                                    <img src="static/assets/images/user1.png" alt="" id='img-upload'>-->
                                               <img v-if="empProfile != ''" :src="(this.empProfile)"  id='img-upload'/>
                                                <img v-if="empProfile == ''" src="static/assets/images/user1.png" id='img-upload' />
                                                
                                                </div>
                                                <div class="employerpic-upload-btn">
                                                    <div class="input-group">
                                                        <span class="input-group-btn">
                                                        <span class="btn btn-default btn-file o-upload-trigger">
                                                            <input type="file" id="imgInp" @change="addProfileImg($event)">
                                                            </span>
                                                        </span>
                                                        <input type="text" class="form-control" readonly>
                                                    </div>
                                                    <i class="fa fa-plus"></i>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-9">
                            <div class="c-common-space c-common-box-shadow c-radius3">
                                <div class="c-user-tab-content clearfix o-skillset-area">
                                    <p>Basic Info:</p>
                                    <div class="row">
                                        <div class="col-sm-4">
                                            <div class="form-group ">
                                                <label class="common-label-text">User Name:</label>
                                                <input type="text" class="form-control" placeholder="Name" v-validate="{ required: true}" name="name" v-model="addEmployer.name">
                                                 <span v-show="errors.has('name') && this.validation_err!=0" class="err-msg">{{ errors.first('name') }}</span>
                                            </div>
                                        </div>
                                        <div class="col-sm-4">
                                            <div class="form-group ">
                                                <label class="common-label-text">Password:</label>
                                                <input type="password" class="form-control" placeholder="Password" v-validate="'min:6'" name="password" v-model="addEmployer.password">
                                                 <span v-show="errors.has('password') && this.validation_err!=0" class="err-msg">{{ errors.first('password') }}</span>
                                            </div>
                                        </div>
                                        <div class="col-sm-4">
                                            <div class="form-group ">
                                                <label class="common-label-text">Confirm Password:</label>
                                                <input type="password" class="form-control" placeholder="Re-type Password" v-validate="'confirmed:password'" name="repassword" v-model="addEmployer.repassword">
                                                <span v-show="errors.has('repassword') && this.validation_err!=0" class="err-msg">{{ errors.first('repassword') }}</span>
                                                                                           
                                            </div>
                                        </div>
                                        <div class="col-sm-4">
                                            <div class="form-group ">
                                                <label class="common-label-text">Employer Name:</label>
                                                <input type="text" class="form-control" placeholder="Employer Name" v-validate="{ required: true}" name="employerName" v-model="addEmployer.employerName">
                                                <span v-show="errors.has('employerName') && this.validation_err!=0" class="err-msg">{{ errors.first('employerName') }}</span>
                                            </div>
                                        </div>
                                        <div class="col-sm-4">
                                            <div class="form-group ">
                                                <label class="common-label-text">Contact Person Name:</label>
                                                <input type="text" class="form-control" placeholder="Contact Person Name" name="contactPersonName" v-model="addEmployer.contactPersonName">
                                            </div>
                                        </div>
                                        <div class="col-sm-4">
                                            <div class="form-group ">
                                                <label class="common-label-text">Contact Person Name 2:</label>
                                                <input type="text" class="form-control" placeholder="Contact Person Name 2" name="contactPersonName2" v-model="addEmployer.contactPersonName2">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field-group">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="c-common-space c-common-box-shadow c-radius3">
                                <div class="c-user-tab-content clearfix o-skillset-area">
                                    <p>Address:</p>
                                    <div class="row">
                                        <div class="col-sm-3">
                                            <div class="form-group">
                                                <label class="common-label-text">Street Address:</label>
                                                <input type="text" class="form-control" placeholder="Street Address" v-validate="{ required: true}" name="streetAddress" v-model="addEmployer.streetAddress">
                                                <span v-show="errors.has('streetAddress') && this.validation_err!=0" class="err-msg">{{ errors.first('streetAddress') }}</span>
                                            </div>
                                        </div>
                                        <div class="col-sm-3">
                                            <div class="form-group ">
                                                <label class="common-label-text">City:</label>
                                                <input type="text" class="form-control" placeholder="City" v-validate="{ required: true}" name="city" v-model="addEmployer.city">
                                                <span v-show="errors.has('city') && this.validation_err!=0" class="err-msg">{{ errors.first('city') }}</span>
                                            </div>
                                        </div>
                                        <div class="col-sm-3">
                                            <div class="form-group ">
                                                <label class="common-label-text">State:</label>
                                                <input type="text" class="form-control" placeholder="State" v-validate="{ required: true}" name="state" v-model="addEmployer.state">
                                                <span v-show="errors.has('state') && this.validation_err!=0" class="err-msg">{{ errors.first('state') }}</span>
                                            </div>
                                        </div>
                                        <div class="col-sm-3">
                                            <div class="form-group ">
                                                <label class="common-label-text">Zip:</label>
                                                <input type="text" class="form-control" placeholder="Zip" v-validate="{ required: true}" name="zip" v-model="addEmployer.zip">
                                                <span v-show="errors.has('zip') && this.validation_err!=0" class="err-msg">{{ errors.first('zip') }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field-group">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="c-common-space c-common-box-shadow c-radius3">
                                <div class="c-user-tab-content clearfix o-skillset-area">
                                    <p>Email:</p>
                                    <div class="row">
                                        <div class="col-sm-3">
                                            <div class="form-group ">
                                                <label class="common-label-text">Primary Email:</label>
                                                <input type="text" class="form-control" placeholder="Email" v-validate="'required|email'" name="email" v-model="addEmployer.email">
                                                <span v-show="errors.has('email') && this.validation_err!=0" class="err-msg">{{ errors.first('email') }}</span>
                                            </div>
                                        </div>
                                        <div class="col-sm-3">
                                            <div class="form-group ">
                                                <label class="common-label-text">Secondary Email:</label>
                                                <input type="email" @keyup="customValEmail($event, addEmployer.secemail)" class="form-control" placeholder="Secondary Email" name="secemail" v-model="addEmployer.secemail">
                                                <span class="err-msg customError">Insert valid email address</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field-group">
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="c-common-space c-common-box-shadow c-radius3">
                                <div class="c-user-tab-content clearfix o-skillset-area">
                                    <p>Phone & Fax:</p>
                                    <div class="row">
                                        <div class="col-sm-3">
                                            <div class="form-group ">
                                                <label class="common-label-text">Primary Phone:</label>
                                                <input type="number" class="form-control" placeholder="Primary Phone" v-validate="{ required: true}" name="priphone" v-model="addEmployer.priphone">
                                                <span v-show="errors.has('priphone') && this.validation_err!=0" class="err-msg">{{ errors.first('priphone') }}</span>
                                            </div>
                                        </div>
                                        <div class="col-sm-3">
                                            <div class="form-group ">
                                                <label class="common-label-text">Secondary Phone:</label>
                                                <input type="number" @keyup="customVal($event, addEmployer.secphone)" class="form-control" placeholder="Secondary Phone Number" name="secphone" v-model="addEmployer.secphone">
                                                <span class="err-msg customError">Number should be minimum 10 digit</span>
                                            </div>
                                        </div>
                                        <div class="col-sm-3">
                                            <div class="form-group ">
                                                <label class="common-label-text">Cell Phone:</label>
                                                <input type="number" @keyup="customVal($event, addEmployer.cellphone)" class="form-control" placeholder="Cell Phone" name="cellphone" v-model="addEmployer.cellphone">
                                                <span class="err-msg customError">Number should be minimum 10 digit</span>
                                            </div>
                                        </div>
                                        <div class="col-sm-3">
                                            <div class="form-group ">
                                                <label class="common-label-text">Fax:</label>
                                                <input type="number" @keyup="customVal($event, addEmployer.fax)" class="form-control" placeholder="Fax Number" name="fax" v-model="addEmployer.fax">
                                               <span class="err-msg customError">Number should be minimum 10 digit</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="field-group">
                            <div class="row">
                                <div class="col-sm-6 o-margin-bottom-20">
                                    <div class="col-md-12 o-no-padding">
                                        <h5 class="h2">Notes:</h5>
                                    </div>
                                     <div class="col-md-12 o-no-padding"> 
                                        <div class="o-notes-toggle-container c-common-box-shadow c-radius3">
                                            
                                            <div v-for="(note,key) in notes" v-bind:class="(key==0)?'js-active-togg':''"  class="o-toggle-header">
                                                <a href="javascript: void(0)" v-on:click="toggleHeader(key)" :id="key" class="o-toggle-trigger">
                                                    <i v-bind:class="(key==0)?'fa-minus-circle':'fa-plus-circle'" class="fa " aria-hidden="true"></i>
                                                </a>
                                                <div class="o-toggle-content">
                                                    <div v-bind:class="(key==0)?'js-togg-expand-height':''"  class="js-note-txt-expand ">
                                                        <p class="ps1">{{ note.content }}</p>
                                                    </div>
                                                    <h5 class="ps2">Created by: {{ getNoteAuthor(note) }} 
                                                    <a href="javascript: void(0)" @click="editSingleNotes(note)" v-show="(getNoteAuthor(note)!='Me')? false:true"><i class="fa fa-pencil" aria-hidden="true"></i></a></h5>
                                                </div>
                                            </div>
                                            <div v-if="notes.length == 0" class="">
                                                <div class="o-attachment-strip">No notes found</div>
                                            </div> 
                                        </div>
                                    </div>
                                    <div class="col-md-12 o-no-padding">
                                        <a href="javascript: void(0)" @click="addSingleNotes()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-plus" aria-hidden="true"></i> Add Note</a>
                                    </div>
                                </div>
                                
                                <div class="col-sm-6 o-no-padding o-margin-bottom-20">
                                    <div class="col-md-12">
                                        <h5 class="h2">Documents:</h5>
                                    </div>
                                    <div v-if="attachmentList.length>0" class="col-md-12">
                                        <div class="o-notes-toggle-container c-bg-white u-pad-all-15 c-common-box-shadow c-radius3">
                                            <ul class="o-documents-container">
                                                <li v-for="(attachment, key) in attachmentList">
                                                    <div class="col-md-4 o-no-padding o-uploaded-doc">
                                                        <span><i class="fa fa-file-o" aria-hidden="true"></i></span> {{attachment.filename}}
                                                    </div>
                                                    <div class="col-md-8 o-no-padding o-uploaded-doc-owner">
                                                        <div class="o-inlineblock o-attachmentdate">
                                                            <i class="fa fa-calendar" aria-hidden="true"></i> {{getDate(employerData.attachments[key].created_at)}} <i class="fa fa-clock-o" aria-hidden="true"></i> {{getTime(employerData.attachments[key].created_at)}}
                                                        </div>
                                                        <div class="o-inlineblock text-right">
                                                            <h5>Created by: {{ getNoteAuthor(attachment) }}
                                                                <a href="javascript: void(0)" @click="deleteAtteachment(attachment.id)" v-show="(getNoteAuthor(attachment)!='Me')? false:true">
                                                                   <i v-show="(getNoteAuthor(attachment)!='Me')? false:true" class="fa fa-trash-o" aria-hidden="true"></i>
                                                               </a>
                                                            </h5>
                                                        </div>
                                                    </div>
                                                </li>
                                                               
                                            </ul>
                                        </div>
                                    </div>
                                    <div v-if="attachmentList.length == 0" class="col-md-12">
                                        <div class="o-file-strip c-common-box-shadow">No Document uploaded</div>
                                    </div>  
                                    <div class="col-md-12">
                                        <h5 class="h2">Upload Documents:</h5>
                                    </div>
                                    <div class="col-md-12">
                                        <ul class="o-filter-area">
                                            <li>
                                                <label class="common-label-input--modalwidth o-upload-file upload-btn-wrapper">
                                                    <button class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-green"><i class="fa fa-plus" aria-hidden="true"></i> Add Files</button>
                                                    <input type="file" @change="addFileToList($event)" />
                                                </label>
                                            </li>
                                            <li><a  href="javascript: void(0)" @click="uploadImage()" class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-orange"><i class="fa fa-upload" aria-hidden="true"></i> Start Upload</a></li>
                                            <li><a href="javascript: void(0)" @click="cancelUpload()" class="c-common-btn c-common-btn--small c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel Upload</a></li>
                                            <li><a href="javascript: void(0)" @click="deleteDocuments()" class="c-common-btn c-common-btn--small c-common-btn--inverse-icon"><i class="fa fa-trash-o" aria-hidden="true"></i> Delete</a></li>
                                        </ul>
                                    </div>
                                    <div class="col-md-12">
                                        <div class="upload-table-list o-uploaded-box c-common-box-shadow">
                                            <div class="calls-table-row o-upload-devider" v-for="(img,key) in new_files" v-loading.this.lock="img.uploading">
                                                <div class="calls-table-cell">
                                                    <div class="checkbox o-custom-radio">
                                                        <label>
                                                            <input type="checkbox" :name="key" value="" v-model="img.status">
                                                            <span class="cr"><i class="cr-icon fa fa-check"></i></span>
                                                        </label>
                                                    </div>
                                                </div>
                                            <div class="calls-table-cell">

                                                <div class="calls-table-cell-inner-table">
                                                    <div class="o-accordion-subtext user-icon o-uploaded-image o-no-padding-left">
                                                        <div class="o-post-logged o-post-logged--table-user">
                                                            <div class="o-user-profile-img o-user-profile-img--upload">
<!--                                                            <img :src="img.img">-->
                                                           <img v-if="!img.fileExtension" :src="img.img">
			                                    <img v-else src="static/assets/images/Document-icon.png">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="o-accordion-subtext o-rowtable-text">
                                                        <div>{{img.name}}</div>
                                                    </div>
                                                </div>
                                                    <el-progress :percentage="img.progress" :status="(img.progress == 100)?'success':''"></el-progress>		     
                                            </div>
                                        </div>
                                        <div v-if="new_files.length == 0" class="">
                                            <div class="o-attachment-strip">Upload your Documents</div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="new_files.length > 0" class="col-md-12">
                                    <ul class="o-filter-area">
                                        <li>
                                            <a href="javascript: void(0)" @click="cancelSave()" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                                        </li>
                                        <li>
                                            <a href="javascript: void(0)" @click="uploadSave()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-floppy-o" aria-hidden="true"></i> Save</a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                                
                            </div>
                        </div>
            </div>
            <!-- /Main Body Content area -->
        </div>
        <!-- /Main Content Area -->
        
        <modal name="add-single-notes"  height="auto" :scrollable="true" class="modal-dialog modal-sm modal--custom">
            <div tabindex="-1" role="dialog">
               <div role="document">
                   <div class="modal-content o-common-modal-content">
                <div class="modal-header u-no-border text-center modal-header--heading">
                    <button @click="closeSingleNotes()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><i class="fa fa-times" aria-hidden="true"></i></button>
                    <h1 class="modal-title">Add Notes</h1>
                </div>
                <div class="modal-body c-common-box-shadow o-modal-body">
                    
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="form-group">
                                <label class="common-input--fullwidth">
                                    <textarea class="form-control" rows="4" placeholder="Type your note" v-validate="{required: true}" name="note" v-model="addEmployer.note"></textarea>
                                    <span v-show="errors.has('note') && this.validation_err!=0" class="err-msg">{{ errors.first('note') }}</span>
                                </label>
                            </div>
                        </div>

                    </div>
                </div>
                
                <div class="modal-footer text-center">
                    <ul class="o-filter-area">
                        <li>
                            <a href="javascript: void(0)" @click="closeSingleNotes()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                        </li>
                        <li>
                            <a href="javascript: void(0)" @click="addNewNote()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-floppy-o" aria-hidden="true"></i> Save</a>
                        </li>
                    </ul>
                </div>

            </div>
                   <!-- /.modal-content -->
               </div>
               <!-- /.modal-dialog -->
           </div>
      </modal>
        
        <modal name="edit-single-notes"  height="auto" :scrollable="true" class="modal-dialog modal-sm modal--custom">
            <div tabindex="-1" role="dialog">
               <div role="document">
                   <div class="modal-content o-common-modal-content">
                <div class="modal-header u-no-border text-center modal-header--heading">
                    <button @click="closeEditSingleNotes()" type="button" class="close custom-modal--close" data-dismiss="modal" aria-label="Close"><i class="fa fa-times" aria-hidden="true"></i></button>
                    <h1 class="modal-title">Edit Notes</h1>
                </div>
                <div class="modal-body c-common-box-shadow o-modal-body">
                    
                    <div class="row">
                        <div class="col-sm-12">
                            <div class="form-group">
                                <label class="common-input--fullwidth">
                                    <textarea class="form-control" rows="4" placeholder="Edit your note" v-validate="{required: true}" name="note" v-model="addEmployer.note"></textarea>
                                    <span v-show="errors.has('note') && this.validation_err!=0" class="err-msg">{{ errors.first('note') }}</span>
                                </label>
                            </div>
                        </div>

                    </div>
                </div>
                
                <div class="modal-footer text-center">
                    <ul class="o-filter-area">
                        <li>
                            <a href="javascript: void(0)" @click="closeEditSingleNotes()" data-dismiss="modal" aria-label="Close" class="c-common-btn c-common-btn--large c-common-btn--inverse-icon-blue"><i class="fa fa-minus-circle" aria-hidden="true"></i> Cancel</a>
                        </li>
                        <li>
                            <a href="javascript: void(0)" @click="editNewNote()" class="c-solid-btn c-solid-btn--large c-solid-btn--green"><i class="fa fa-floppy-o" aria-hidden="true"></i> Save</a>
                        </li>
                    </ul>
                </div>

            </div>
                   <!-- /.modal-content -->
               </div>
               <!-- /.modal-dialog -->
           </div>
      </modal>
        
	</div>
</template>
<script>
    import dateTimeConvert from '../../timeConvert&Compare';
    import {
        mapGetters,
        mapActions
    } from 'vuex';
    import {
        global
    } from '../../global.js';
    import {
        bus
    } from '../../main';
    import service from '../../services.js';

    export default {
        data() {
            return {
                pictureExtension: false,
                empProfile: '',
                getBaseURL: '',
                empPersonal: {
                    new_files: [],
                },
                addEmployer: {
                    name: '',
                    password: '',
                    repassword: '',
                    employerName: '',
                    contactPersonName: '',
                    contactPersonName2: '',
                    streetAddress: '',
                    city: '',
                    state: '',
                    zip: '',
                    email: '',
                    secemail: '',
                    priphone: '',
                    secphone: '',
                    cellphone: '',
                    fax: '',
                    note: '',
                },
                validation_err: 0,
                notes: [],
                editNote: {
                    content: '',
                    noteable_id: '',
                    noteable_type: '',
                    uploader: '',
                    noteID: '',
                },
                attachmentList: [],
                new_files: [],
                employerData: [],
            }
        },

        computed: {
            ...mapGetters({
                userToken: 'userToken',
                userRole: 'userRole',
                userClientID: 'userClientID',
                employerID: 'selectedEmployerId',
                userName: 'userName',
                userFullName: 'userFullName',
                userId: 'userID',
                userID: 'userID',
                noteId: 'getNoteId',
                employeeId: 'employeeId'
            })
        },
        methods: {
            getDate(str) {
                return dateTimeConvert.globalDate(str);
                //var date = str.split(" ");
                //return date[0];
            },
            getTime(dateTime) {
                return dateTimeConvert.globalTime(dateTime);
                //var time = dateTimeConvert.extractTimeOnly(dateTime);
                //time = dateTimeConvert.convertTo12Hours(time);
                //return time;
            },

            addProfileImg(e) {
                var input = e.target;
                var img;
                if (input.files && input.files[0]) {
                    var reader = new FileReader();
                    if (input.files[0].size < 500000) {
                        reader.onload = (e) => {
                            img = e.target.result;
                            var type = input.files[0].type.split("/");
                            this.empPersonal.new_files[0] = {
                                'img': img,
                                'name': input.files[0].name,
                                'status': true,
                                'uploading': false,
                                'uploaded': false,
                                'path': '',
                                'type': type[0],
                                'progress': 0,
                                'label': 'Report'

                            };
                        }
                        reader.readAsDataURL(input.files[0]);
                    } else {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: 'Document size should be less than 500 kb'
                        });
                    }
                    this.onUpdateInputField();

                }
            },
            uploadProfileImg() {
                if (this.empPersonal.new_files.length != 0) {
                    service.post('attachment/uploadSingleFile', {
                            'image_file': this.empPersonal.new_files[0].img,
                            'file_name': this.empPersonal.new_files[0].name
                        }, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID
                        })
                        .then((res) => {
                            this.empPersonal.new_files[0].path = res.data.result.path;
                            this.empPersonal.new_files[0].uploaded = true;
                            //console.log('RESPONSONE', res);
                            this.addEmployerForm();
                        }).catch((err) => {
                            console.log(err);
                        });
                } else {

                    this.addEmployerForm();
                }

            },
            onUpdateInputField() {
                //this.$store.dispatch('saveEmployeeBasicInfo', this.empPersonal.basicInfo);
                bus.$emit('onUpdatePersonalDetails', this.empPersonal);
                //console.log(this.empPersonal);
            },
            getNotes() {
                service.get('hiring-organization/' + this.employerID, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                }).
                then((res) => {
                    //this.venues = res.data.result.data;
                    const response = res.data.result;
                    this.notes = response.hiring_entities[0].notes;
                    //console.log("NOTES", this.notes);
                }).catch((err) => {
                    console.log(err);
                });
            },
            getNoteAuthor(note) {
                var getAuthor = JSON.parse(note.activity);
                if (getAuthor.uploader_id == this.userID) {
                    return "Me";
                } else {
                    return getAuthor.uploaded_by;
                }
            },
            editSingleNotes(note) {
                this.$modal.show("edit-single-notes");
                this.addEmployer.note = note.content;
                var noteActivity = JSON.parse(note.activity);

                this.editNote.noteID = note.id;
                this.editNote.content = this.addEmployer.note;
                this.editNote.noteable_id = note.noteable_id;
                this.editNote.noteable_type = note.noteable_type;
                this.editNote.uploader = this.userID;
            },
            closeEditSingleNotes() {
                this.$modal.hide("edit-single-notes");
            },
            editNewNote() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        //console.log("success");
                        this.validation_err = 0;
                        this.editNote.content = this.addEmployer.note;
                        service.put('note/' + this.editNote.noteID, this.editNote, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID
                        }).
                        then((res) => {
                            //this.employers = res.data.result;
                            //this.closeSingleNotes();
                            setTimeout(() => {
                                this.$modal.hide('edit-single-notes');
                            }, 500);
                            this.$notify({
                                title: this.$t('success'),
                                message: 'Employer Note Updated Successfully.',
                                type: 'success'
                            });
                            //console.log('success note');
                            this.getNotes();
                        }).catch((err) => {
                            //console.log(err);
                            //this.$Progress.finish();
                            //console.log('error note');
                        });
                    } else {
                        this.validation_err = 1;
                    }
                });
            },
            addNewNote() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        //console.log("success");
                        this.validation_err = 0;
                        var activityID = {
                            "uploader_id": this.userID,
                            "uploaded_by": this.userFullName,
                        }
                        activityID = JSON.stringify(activityID);
                        var employerNote = {
                            noteable_id: this.noteId,
                            noteable_type: 'employer',
                            activity: activityID,
                            content: this.addEmployer.note,
                        };
                        service.post('note', employerNote, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID
                        }).
                        then((res) => {
                            //this.employers = res.data.result;
                            //this.closeSingleNotes();
                            setTimeout(() => {
                                this.$modal.hide('add-single-notes');
                            }, 500);
                            this.$notify({
                                title: this.$t('success'),
                                message: 'Employer Note Added Successfully.',
                                type: 'success'
                            });
                            //console.log('success note');
                            this.getNotes();
                        }).catch((err) => {
                            console.log(err);
                            //this.$Progress.finish();
                            // console.log('error note');
                        });
                    } else {
                        this.validation_err = 1;
                    }
                });
            },
            backToEmployerList() {
                this.addEmployer = {
                    name: '',
                    password: '',
                    repassword: '',
                    employerName: '',
                    contactPersonName: '',
                    contactPersonName2: '',
                    streetAddress: '',
                    city: '',
                    state: '',
                    zip: '',
                    email: '',
                    secemail: '',
                    priphone: '',
                    secphone: '',
                    cellphone: '',
                    fax: '',
                };
                this.$router.push({
                    path: `/employerList`
                });
            },

            addEmployerForm() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        //console.log("success");
                        this.validation_err = 0;
                        if (this.empPersonal.new_files.length > 0) {
                            this.empProfile = this.empPersonal.new_files[0].path;
                        }
                        //console.log('Handle', this.empProfile);
                        //console.log(this.addEmployer);
                        var editEmployerData = {
                            client_id: this.userClientID,
                            name: this.addEmployer.employerName,
                            display_name: this.addEmployer.name,
                            //password: this.addEmployer.password,
                            email: this.addEmployer.email,
                            secondary_email: this.addEmployer.secemail,
                            contact_person_one: this.addEmployer.contactPersonName,
                            contact_person_two: this.addEmployer.contactPersonName2,
                            address: this.addEmployer.streetAddress,
                            country: '',
                            municipality: this.addEmployer.city,
                            postcode: this.addEmployer.zip,
                            state_province: this.addEmployer.state,
                            primary_phone: this.addEmployer.priphone,
                            secondary_phone: this.addEmployer.secphone,
                            cell_phone: this.addEmployer.cellphone,
                            fax: this.addEmployer.fax,
                            notes: '',
                            image: this.empProfile,

                        };
                        service.put('hiring-organization/' + this.employerID, editEmployerData, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID
                        }).
                        then((res) => {
                            this.employers = res.data.result;
                            //this.$Progress.finish();
                            this.$notify({
                                title: this.$t('success'),
                                message: 'Employer Updated Successfully.',
                                type: 'success'
                            });
                            this.backToEmployerList();
                            //console.log(res);
                        }).catch((err) => {
                            console.log(err);
                            //this.$Progress.finish();
                        });

                    } else {
                        this.validation_err = 1;
                    }
                });
            },
            customVal(event, customField) {
                if (customField !== "") {
                    if (customField.length !== 10) {
                        $(event.target).next(".customError").css("display", "block");
                        //this.secondaryPhone = true;
                    } else {
                        $(event.target).next(".customError").css("display", "none");
                    }
                }
            },
            customValEmail(event, customEmailField) {
                if (customEmailField !== "") {
                    const filter = /^([\w-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]+\.)+))([a-zA-Z]{2,4}|[0-9]{1,3})(\]?)$/;
                    if (filter.test(customEmailField)) {
                        $(event.target).next(".customError").css("display", "none");
                    } else {
                        $(event.target).next(".customError").css("display", "block");
                    }
                }
            },
            phoneNumberCheck(phone_number, type) {
                let self = this;
                let primaryPhone = "";
                phone_number.forEach(function(employerphone) {
                    if (employerphone.label == type) {
                        //console.log(employerphone.label);
                        primaryPhone = employerphone.phone_number;
                    }
                });
                return primaryPhone;

            },

            toggleHeader(id) {
                //console.log(id);
                if ($('#' + id).children().hasClass("fa-plus-circle")) {
                    //console.log("open");
                    $('#' + id).parent().addClass('js-active-togg');
                    $('#' + id).children().removeClass('fa-plus-circle').addClass('fa-minus-circle');
                    $('#' + id).siblings(".o-toggle-content").children(".js-note-txt-expand").addClass("js-togg-expand-height");
                } else {
                    //console.log('close');
                    $('#' + id).parent().removeClass('js-active-togg');
                    $('#' + id).children().removeClass('fa-minus-circle').addClass('fa-plus-circle');
                    $('#' + id).siblings(".o-toggle-content").find(".js-note-txt-expand").removeClass("js-togg-expand-height");
                }
            },
            addSingleNotes() {
                this.$modal.show("add-single-notes");
                this.addEmployer.note = '';
            },
            closeSingleNotes() {
                this.$modal.hide("add-single-notes");
            },

            getEmployerDetails() {
                this.$Progress.start();
                service.get('hiring-organization/' + this.employerID, {
                    'Authorization': this.userToken,
                    'cs3-context-role': this.userRole,
                    'cs3-context-clientId': this.userClientID
                }).
                then((res) => {
                    //console.log(res);
                    //this.venues = res.data.result.data;
                    this.$Progress.finish();
                    const response = res.data.result;

                    //this.addEmployer.name = response.hiring_entities[0].user.first_name + " " + response.hiring_entities[0].user.last_name;
                    this.addEmployer.name = response.hiring_entities[0].user.display_name;
                    //this.addEmployer.password = '';
                    //this.addEmployer.repassword = '';
                    this.addEmployer.employerName = response.name;
                    this.addEmployer.contactPersonName = response.contact_person_one;
                    this.addEmployer.contactPersonName2 = response.contact_person_two;
                    this.addEmployer.streetAddress = response.addresses[0].address;
                    this.addEmployer.city = response.addresses[0].municipality;
                    this.addEmployer.state = response.addresses[0].state_province;
                    this.addEmployer.zip = response.addresses[0].postcode;
                    this.addEmployer.email = response.hiring_entities[0].user.email;
                    this.addEmployer.secemail = response.hiring_entities[0].user.secondary_email;
                    this.addEmployer.priphone = this.phoneNumberCheck(response.phones, "Primary phone");
                    this.addEmployer.secphone = this.phoneNumberCheck(response.phones, "Secondary phone");
                    this.addEmployer.cellphone = this.phoneNumberCheck(response.phones, "Cell phone");
                    this.addEmployer.fax = this.phoneNumberCheck(response.phones, "Fax");
                    this.notes = response.hiring_entities[0].notes;
                    this.empProfile = response.hiring_entities[0].user.image;
                    this.employerData = response.hiring_entities[0];
                    this.attachmentList = this.employerData.attachments;
                    //console.log("PATH", this.empProfile);
                    //console.log("RESPONSE", response.hiring_entities[0].user.image);

                }).catch((err) => {
                    console.log(err);
                });
            },

            addFileToList(e) {
                var input = e.target;
                var img;
                if (input.files && input.files[0]) {
                    var reader = new FileReader();
                    if (input.files[0].size < 2500000) {
                        reader.onload = (e) => {
                            img = e.target.result;
                            var type = input.files[0].type.split("/");
                            this.new_files.push({
                                'img': img,
                                'name': input.files[0].name,
                                'status': true,
                                'uploading': false,
                                'uploaded': false,
                                'path': '',
                                'type': type[0],
                                'progress': 0,
                                'label': 'Report',
                                'fileExtension': this.setPicture(type[0])
                            });
                        }
                        reader.readAsDataURL(input.files[0]);
                    } else {
                        this.$notify.error({
                            title: this.$t('error'),
                            message: 'Document size should be less than 2 MB'
                        });
                    }

                }
            },
            setPicture(extension) {
                if (extension == 'application' || extension == 'text') {
                    return true;
                }
                return false;
            },
            uploadImage() {
                //console.log(this.new_files);
                for (var i = 0; i < this.new_files.length; i++) {

                    if (this.new_files[i].status == true && this.new_files[i].uploaded == false) {
                        this.new_files[i].progress = 20;
                        this.uploadService(this.new_files[i]).then((path) => {
                            //console.log(path);
                        }).catch((err) => {
                            console.log(err);
                        });

                    }
                    //console.log(this.new_files);
                }
            },
            uploadService(img) {
                img.progress = 50;
                var promise1 = new Promise((resolve, reject) => {
                    service.post('attachment/uploadSingleFile', {
                            'image_file': img.img,
                            'file_name': img.name
                        }, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID
                        })
                        .then((res) => {
                            resolve(res);
                            img.path = res.data.result.path;
                            img.progress = 100;
                            img.uploaded = true;
                        }).catch((err) => {
                            reject(err);
                        });
                });
                return promise1;

            },
            uploadSave() {
                let self = this;
                //console.log(this.new_files);
                let unUploadFile = this.new_files.filter(function(file) {
                    //console.log(file.uploaded); 
                    return (file.uploaded == false);
                });
                //console.log(unUploadFile);
                if (unUploadFile.length > 0) {
                    this.$confirm('Some file are still not uploaded. Do you want to save all files ?', 'Warning', {
                        confirmButtonText: 'Yes',
                        cancelButtonText: 'No',
                        type: 'warning'
                    }).then(() => {
                        this.new_files.forEach(function(file) {
                            if (!file.status) {
                                file.status = true;
                            }
                        });
                        // Upload un-uploaded files.
                        for (var i = 0; i < this.new_files.length; i++) {

                            if (this.new_files[i].status == true && this.new_files[i].uploaded == false) {
                                this.new_files[i].progress = 20;
                                this.uploadService(this.new_files[i]).then((path) => {

                                    //save all file in database.
                                    for (var i = 0; i < this.new_files.length; i++) {
                                        let activityData = {
                                            uploader_id: this.userId,
                                            uploaded_by: this.userFullName,
                                        };
                                        let fromData = {
                                            attachable_id: this.employerData.id,
                                            created_by: this.employeeId,
                                            attachable_type: 'employer',
                                            filename: this.new_files[i].name,
                                            description: 'Employer Document',
                                            label: this.new_files[i].label,
                                            path: this.new_files[i].path,
                                            activity: JSON.stringify(activityData)
                                        };
                                        this.saveService(fromData).then((res) => {
                                            //console.log(res);
                                            this.$message({
                                                type: 'success',
                                                message: 'File saved successfully'
                                            });
                                            this.new_files = [];
                                        }).catch((err) => {
                                            console.log(err);
                                        });
                                    }

                                }).catch((err) => {
                                    console.log(err);
                                });

                            }
                            //console.log(this.new_files);
                        }
                        //console.log("data");
                    }).catch(() => {

                        /*delete un-uploaded files.*/
                        this.new_files.forEach(function(file, key) {
                            //console.log(key);
                            if (!file.uploaded) {
                                self.new_files.splice(key, 1);
                            }
                        });

                        /* save uploaded files.*/
                        for (var i = 0; i < this.new_files.length; i++) {
                            let activityData = {
                                uploader_id: this.userId,
                                uploaded_by: this.userFullName,
                            };
                            let fromData = {
                                attachable_id: this.employerData.id,
                                created_by: this.employeeId,
                                attachable_type: 'employer',
                                filename: this.new_files[i].name,
                                description: 'Employer Document',
                                label: this.new_files[i].label,
                                path: this.new_files[i].path,
                                activity: JSON.stringify(activityData)
                            };
                            this.saveService(fromData).then((res) => {
                                this.$message({
                                    type: 'success',
                                    message: 'File saved successfully'
                                });
                                this.new_files = [];
                            }).catch((err) => {
                                console.log(err);
                            });
                        }
                    });

                } else {
                    //console.log("uploaded");
                    for (var i = 0; i < this.new_files.length; i++) {
                        let activityData = {
                            uploader_id: this.userId,
                            uploaded_by: this.userFullName,
                        };
                        let fromData = {
                            attachable_id: this.employerData.id,
                            created_by: this.employeeId,
                            attachable_type: 'employer',
                            filename: this.new_files[i].name,
                            description: 'Employer Document',
                            label: this.new_files[i].label,
                            path: this.new_files[i].path,
                            activity: JSON.stringify(activityData)
                        };
                        this.saveService(fromData).then((res) => {
                            this.$message({
                                type: 'success',
                                message: 'File saved successfully'
                            });
                            this.new_files = [];
                        }).catch((err) => {
                            console.log(err);
                        });
                    }
                }
                //document.reload();

                this.getEmployerDetails();
            },
            saveService(data) {
                //img.progress = 50;
                var promise1 = new Promise((resolve, reject) => {
                    service.post('attachment', data, {
                            'Authorization': this.userToken,
                            'cs3-context-role': this.userRole,
                            'cs3-context-clientId': this.userClientID
                        })
                        .then((res) => {
                            resolve(res);
                            this.getEmployerDetails();
                        }).catch((err) => {
                            reject(err);
                        });
                });
                return promise1;

            },
            cancelSave() {
                this.new_files = [];
            },
            cancelUpload() {
                this.count = 0;
                for (this.count = 0; this.count < this.new_files.length; this.count++) {
                    if (this.new_files[this.count].uploaded == false) {
                        this.new_files.splice(this.count, 1);
                    }
                }
            },
            deleteDocuments() {
                this.count = 0;
                for (this.count = 0; this.count < this.new_files.length; this.count++) {
                    if (this.new_files[this.count].status == true) {
                        this.new_files.splice(this.count, 1);
                    }
                }
            },
            deleteAtteachment(id) {
                this.$confirm('This will permanently delete the file. Continue?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                }).then(() => {
                    service.post('attachment/destroy', {
                        'attachment_id': id
                    }, {
                        'Authorization': this.userToken,
                        'cs3-context-role': this.userRole,
                        'cs3-context-clientId': this.userClientID
                    }).
                    then((res) => {
                        //this.$Progress.finish();
                        this.$message({
                            type: 'success',
                            message: 'Delete completed'
                        });
                        this.getEmployerDetails()
                    }).catch((err) => {
                        console.log(err);
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: 'Delete canceled'
                    });
                });
            },

        },
        mounted() {

            $(document).on('change', '.btn-file :file', function() {
                var input = $(this),
                    label = input.val().replace(/\\/g, '/').replace(/.*\//, '');
                input.trigger('fileselect', [label]);
            });

            $('.btn-file :file').on('fileselect', function(event, label) {
                var input = $(this).parents('.input-group').find(':text'),
                    log = label;
                if (input.length) {
                    input.val(log);
                } else {
                    if (log) alert(log);
                }
            });

            function readURL(input) {
                if (input.files && input.files[0]) {
                    var reader = new FileReader();
                    reader.onload = function(e) {
                        $('#img-upload').attr('src', e.target.result);
                    }
                    reader.readAsDataURL(input.files[0]);
                }
            }

            $("#imgInp").change(function() {
                readURL(this);
            });
        },
        created() {
            this.getBaseURL = global[0].IMAGE_URL;
            this.getEmployerDetails();

            //console.log(this.employerID);



        }
    }

</script>



// WEBPACK FOOTER //
// src/components/employers/editEmployer.vue